import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { REPORT_CTA_CLICK } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default projectId => async dispatch => dispatch(
	apiRequest(REPORT_CTA_CLICK, { projectId }),
)
